<template>
  <v-form
    ref="passwordForm"
    @submit.prevent="resetPassword"
    :errorMessages="errors.detail"
    lazy-validation
    class="fill-height"
  >
    <v-card flat class="fill-height">
      <v-card-title>Change Password</v-card-title>
      <v-card-text>
        <v-alert dense outlined type="success" v-if="passwordChanged">
          Password changed successfuly.
        </v-alert>
        <v-alert dense outlined type="error" v-if="errors.token">
          <ul>
            <li v-for="error in errors.token" :key="error">{{ error }}</li>
          </ul>
        </v-alert>
        <v-text-field
          v-model="currentPassword"
          label="Current Password"
          type="password"
          outlined
          dense
          :rules="currentPasswordRules"
          :errorMessages="errors.currentPassword"
        ></v-text-field>
        <v-text-field
          v-model="password"
          label="Password"
          type="password"
          outlined
          dense
          :rules="passwordRules"
          :errorMessages="errors.newPassword"
          @change="$refs.passwordForm.validate()"
        ></v-text-field>
        <v-text-field
          v-model="passwordConfirm"
          label="Confirm Password"
          type="password"
          outlined
          dense
          :rules="passwordRules"
          :errorMessages="errors.password"
          @change="$refs.passwordForm.validate()"
        ></v-text-field>
      </v-card-text>
      <v-spacer></v-spacer>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn type="submit" color="primary" text :disabled="submitted">
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { changePassword } from "@/services/api/auth";
import { fieldRequired } from "@/form-rules";

export default {
  name: "PasswordChangeForm",
  data() {
    return {
      currentPassword: "",
      password: "",
      passwordConfirm: "",
      errors: {},
      submitted: false,
      passwordChanged: false,
      currentPasswordRules: [fieldRequired()],
      passwordRules: [
        (value) => !!value || "Password is required.",
        (value) => {
          if (
            value != "" &&
            this.password != "" &&
            this.passwordConfirm != ""
          ) {
            return (
              this.password === this.passwordConfirm || "Passwords must match."
            );
          }
          return true;
        },
      ],
    };
  },
  methods: {
    resetPassword() {
      this.submitted = true;
      changePassword(this.currentPassword, this.password)
        .then(() => {
          this.passwordChanged = true;
          this.errors = {};
          (this.currentPassword = ""),
            (this.password = ""),
            (this.passwordConfirm = ""),
            this.$refs.passwordForm.resetValidation();
          this.submitted = false;
        })
        .catch((error) => {
          this.errors = error.response.data;
          this.submitted = false;
        });
    },
  },
};
</script>

<style></style>
